// ABOUTME: "Vertragsanpassungen": the contract changes of my job, or the note that they will be listed here. As a card on
// ABOUTME: the my-job page, or, with PJL, as its own section of the job page (`asJobSection`), in the sections' style:
// ABOUTME: the note in the page's notice box, each change as rows.
import { useTheme } from '@mui/material/styles';
import { ContentCard } from 'components/Card/ContentCard';
import { InfoCard } from 'components/notification-cards';
import { Text } from 'components/Text';
import { useAssignmentDetails } from 'modules/assignment-details';
import { getTrans } from 'modules/i18n';
import {
  JobPageNotice,
  JobPageSection
} from 'modules/jobListings/components/JobPageParts';
import { AssignmentChangeLogSkeleton } from './AssignmentChangeLogSkeleton';
import { ChangeItem } from './ChangeItem';

const JOB_SECTION_HEADING_ID = 'assignment-change-log-title';

export const AssignmentChangeLog = ({
  asJobSection = false
}: {
  asJobSection?: boolean;
}) => {
  const { isLoading, assignmentDetails } = useAssignmentDetails();
  const theme = useTheme();

  if (isLoading) return <AssignmentChangeLogSkeleton />;

  if (!assignmentDetails) return null;

  const { assignmentChanges } = assignmentDetails;

  const changes = assignmentChanges?.length ? (
    assignmentChanges.map(changeData => (
      <ChangeItem key={changeData.refId} changeData={changeData} />
    ))
  ) : (
    <InfoCard sx={{ mb: 2 }}>
      <Text variant="body2">
        {getTrans('assignmentDetailsPage.changeLogInfo')}
      </Text>
    </InfoCard>
  );

  if (asJobSection) {
    return (
      <JobPageSection
        title={getTrans('assignmentDetailsPage.changeLog.title')}
        testId="assignment-change-log-section"
        headingId={JOB_SECTION_HEADING_ID}
      >
        {assignmentChanges?.length ? (
          assignmentChanges.map(changeData => (
            <ChangeItem key={changeData.refId} changeData={changeData} asRows />
          ))
        ) : (
          <JobPageNotice
            body={getTrans('assignmentDetailsPage.changeLogInfo')}
          />
        )}
      </JobPageSection>
    );
  }

  return (
    <ContentCard
      title={getTrans('assignmentDetailsPage.changeLog.title')}
      sx={{
        pb: 0,
        [theme.breakpoints.up('sm')]: {
          pb: 0
        },
        '& > div:first-of-type': {
          mb: 1
        }
      }}
    >
      {changes}
    </ContentCard>
  );
};
